var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 43,
    viewBox: "0 0 22 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.398609 0.16128C0.111749 0.386925 -0.0229665 0.75411 0.0444435 1.12655C0.0943185 1.40249 1.14726 2.48315 9.87622 11.2178L19.6522 21L9.87853 30.7822C1.99219 38.6755 0.0942131 40.6159 0.0495881 40.831C-0.148127 41.7844 0.814513 42.357 1.61514 41.7624C2.41261 41.1701 21.894 21.5339 21.9494 21.2666C22.0829 20.6229 22.5258 21.0983 11.6682 10.2334L1.44147 0H1.02262C0.730304 0 0.541724 0.04872 0.398609 0.16128Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angle-right.8fea365a747d5c0a0c6093848b1d1626.svg";
export { ForwardRef as ReactComponent };